let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f6BA6")).then(() => parcelRequire('heGHy'));